import { NoticeBoardCategoryService } from './../../../shared/services/notice-board-category.service';
import { NoticeBoardService } from './../../../shared/services/notice-board.service';
import { IPaged } from '../../../_models/common/IPaged';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription, combineLatest } from 'rxjs';


@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit, OnDestroy {

  private readonly PAGE_SIZE = 10;

  queryResult: IPaged = {
    pageNumber: 0,
    items: [],
    totalRows: 0,
    pageSize: this.PAGE_SIZE
  };

  query: any = {
    page: 1,
    pageSize: this.PAGE_SIZE,
    sort: 'Id',
    sortDir: 'Descending',
    slug: ''
  };

  noticeBoardCategories: any[];
  noticeBoardCategory: any;
  sub: Subscription;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private service: NoticeBoardService,
    private noticeBoardCategoryService: NoticeBoardCategoryService) {
    
      this.sub = combineLatest(this.route.params, this.route.queryParams,
        (params, qparams) => ({ params, qparams })).subscribe(ap => {
          this.query.page = isNaN(ap.qparams.page) ? 1 : ap.qparams.page;
          this.query.sort = ap.qparams.sort ? ap.qparams.sort : this.query.sort;
          this.query.sortDir = ap.qparams.sortDir ? ap.qparams.sortDir : this.query.sortDir;
          this.query.slug = ap.params.slug;
          this.populateNoticeBoards();
        });

  }

  ngOnInit(): void {
    this.bindDropDown();
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  private populateNoticeBoards() {
    this.service.getAll(this.query)
      .subscribe((response: IPaged) => {
        if (response) {
          this.queryResult = response;
        }
      });
  }

  bindDropDown() {
    this.noticeBoardCategoryService.getAllNoticeBoardCategories().subscribe((response: any[]) => {
      if (response) {
        this.noticeBoardCategories = response;
        if (this.query.slug) {
          this.noticeBoardCategory = this.noticeBoardCategories.find(x => x.slug == this.query.slug);
        }
      }
    });
  }

  change(item) {
    this.query.slug = item.slug;
    this.router.navigate(['/notice-board', this.query.noticeBoardCategoryId], { 
      queryParams: this.query
    });
  }
}
